import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from '../form/index';
import actForm from '../activeForm/index';
import logs from '../logs/index';

export default {
  extends: TablePage,
  components: {
    Form,
    actForm,
    logs,
  },
  name: 'person_info',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('page_list');
  },

  methods: {
    modalClick({ val, row }) {
      console.log(val.code);
      if (val.code === 'view') {
        this.modalConfig.title = '查看';
        this.formConfig = {
          row,
          code: val.code,
        };
        this.openFull();
      }
      if (val.code === 'add') {
        this.modalConfig.title = '新增';
        this.formConfig = {
          code: val.code,
        };
        this.openFull();
      }
      if (val.code === 'edit') {
        this.modalConfig.title = '编辑';
        this.formConfig = {
          code: val.code,
          id: row.id,
          row,
        };
        this.openFull();
      }
      if (val.code === 'look_active') {
        console.log(row);
        this.formName = 'actForm';
        this.modalConfig.title = '查看活动';
        this.propsObjInData.profileCode = row.personCode;
        this.openFull();
      }
      if (val.code === 'info_logs') {
        console.log(row);
        this.formName = 'logs';
        this.modalConfig.title = '操作日志';
        this.propsObjInData.profileCode = row.personCode;
        this.openFull();
      }
      if (val.code === 'enable') {
        console.log(this.selection);
        if (this.selection.length > 0) {
          this.$confirm('确认要启用吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            request.post('/tpm/personprofile/enable', this.selection).then((res) => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '操作成功',
                });
                this.getList();
              }
            });
          });
        } else {
          this.$message('请至少选择一条数据！');
          return false;
        }
      }
      if (val.code === 'disable') {
        console.log(this.selection);
        if (this.selection.length > 0) {
          this.$confirm('确认要禁用吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            request.post('/tpm/personprofile/disable', this.selection).then((res) => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '操作成功',
                });
                this.getList();
              }
            });
          });
        } else {
          this.$message('请至少选择一条数据！');
          return false;
        }
      }
    },
  },
};
